import { render, staticRenderFns } from "./MangLots.vue?vue&type=template&id=14142835&"
import script from "./MangLots.vue?vue&type=script&lang=js&"
export * from "./MangLots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports